const showPopup = (message) => {
    // Show the popup with the provided message
    const popup = document.getElementById('popup');
    popup.textContent = message;
    popup.style.display = 'block';
    // Hide the popup after 2 seconds
    setTimeout(() => {
        popup.style.display = 'none';
    }, 3000);
};

const addCommas = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  
  const unformatNumber = (formattedNumber) => {
    return formattedNumber.replace(/,/g, '');
  };

export { showPopup, addCommas, formatNumberWithCommas, unformatNumber };